import { useConfigStore } from '@/store/configStore';
import { AvailableLanguage, UserShowMoreMessage } from '@/types';

type MessageUserShowMoreProps = {
  message: UserShowMoreMessage;
  messageId: string;
};

const mapLangToShowMoreText = (language: AvailableLanguage) => {
  switch (language) {
    case 'en':
      return 'Show more like this';
    case 'de':
      return 'Mehr wie dieses anzeigen';
    case 'fr':
      return 'Afficher plus comme ceci';
    case 'nl':
      return 'Toon meer als dit';
  }
};

const MessageUserShowMore = ({ message }: MessageUserShowMoreProps) => {
  const { config } = useConfigStore();
  const language = config.language;
  const showMoreText = mapLangToShowMoreText(language as AvailableLanguage);

  return (
    <div className="flex w-full max-w-[87.5%] flex-col overflow-hidden rounded-lg rounded-tr-none border-[1px] border-[#d9d9d9] bg-white">
      <div className="flex gap-[12px] p-[4px]">
        {message.content.image && (
          <img
            src={message.content.image}
            alt={message.content.productName || 'Product'}
            className="h-[80px] w-auto max-w-[50%] flex-shrink-0 rounded-lg rounded-r-none bg-[#f5f5f5] object-cover"
          />
        )}
        <div className="flex flex-1 flex-col justify-center gap-[4px]">
          {message.content.brandName && (
            <h3 className="text-sm font-bold uppercase leading-tight text-widget-text-primary">
              {message.content.brandName}
            </h3>
          )}
          {message.content.productName && (
            <p className="text-sm font-normal leading-tight text-widget-text-primary">
              {message.content.productName}
            </p>
          )}
        </div>
      </div>
      <div className="bg-[#f5f5f5] px-[20px] py-[12px]">
        <p className="text-md text-widget-text-primary">{showMoreText}</p>
      </div>
    </div>
  );
};

export default MessageUserShowMore;
